


















































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UserStore from '@/stores/user/user.store';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import MegacardConnector from '@/views/account/MegacardConnector.vue';
import MegacardStore from '@/stores/user/megacard.store';
import { MegacardRequestDto } from '@/api';
import SmoothShow from '@/views/common/SmoothShow.vue';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';

@Component({
  components: {CmsLink, SmoothShow, MegacardConnector, LoadingIndicator},
})
export default class UserProfile extends Vue {
  public userStore = getModule(UserStore, this.$store);
  public megacardStore = getModule(MegacardStore, this.$store);

  public editing = false;
  public loading = false;

  public get hasMegacard(): boolean {
    return this.userStore.hasMegacard;
  }

  public get megacardInfo(): MegacardRequestDto | null {
    return this.userStore.megacardInfo;
  }

  public get hasMegacardRequest(): boolean {
    return this.megacardStore.hasMegacardRequest;
  }

  public async connectMegacard(): Promise<void> {
    this.loading = true;
    const response = await this.megacardStore.connectRequestedMegacard();
    if (response.success) {
      await this.userStore.fetchUser();
      this.editing = false;
    }
    this.loading = false;
  }

  public startEditing(): void {
    this.editing = true;
  }

  public abortEditing(): void {
    this.megacardStore.resetRequestedMegacard();
    this.editing = false;
  }
}
